import React from 'react'
import moment from 'moment'

// import { InlineIcon } from '@iconify/react'
// import alert from '@iconify/icons-mdi/alert-circle'
// import check from '@iconify/icons-mdi/check-circle'
// import waiting from '@iconify/icons-mdi/clock-check'
import estados from './cidades.json'

export const versionString = 'Versão 1.0b1 (Novembro/2021)'

export const makeThumbnailPath = (fullPath) => {
  // let res = fullPath.replace('images/', 'thumbs/')
  let res = `${fullPath}-small.jpg`
  return res
  // `${path}-thumb.jpg`
}


export const UFs = 
[
  {"nome": "", "sigla": "-"},
  {"nome": "Acre", "sigla": "AC"},
  {"nome": "Alagoas", "sigla": "AL"},
  {"nome": "Amapá", "sigla": "AP"},
  {"nome": "Amazonas", "sigla": "AM"},
  {"nome": "Bahia", "sigla": "BA"},
  {"nome": "Ceará", "sigla": "CE"},
  {"nome": "Distrito Federal", "sigla": "DF"},
  {"nome": "Espírito Santo", "sigla": "ES"},
  {"nome": "Goiás", "sigla": "GO"},
  {"nome": "Maranhão", "sigla": "MA"},
  {"nome": "Mato Grosso", "sigla": "MT"},
  {"nome": "Mato Grosso do Sul", "sigla": "MS"},
  {"nome": "Minas Gerais", "sigla": "MG"},
  {"nome": "Pará", "sigla": "PA"},
  {"nome": "Paraíba", "sigla": "PB"},
  {"nome": "Paraná", "sigla": "PR"},
  {"nome": "Pernambuco", "sigla": "PE"},
  {"nome": "Piauí", "sigla": "PI"},
  {"nome": "Rio de Janeiro", "sigla": "RJ"},
  {"nome": "Rio Grande do Norte", "sigla": "RN"},
  {"nome": "Rio Grande do Sul", "sigla": "RS"},
  {"nome": "Rondônia", "sigla": "RO"},
  {"nome": "Roraima", "sigla": "RR"},
  {"nome": "Santa Catarina", "sigla": "SC"},
  {"nome": "São Paulo", "sigla": "SP"},
  {"nome": "Sergipe", "sigla": "SE"},
  {"nome": "Tocantins", "sigla": "TO"}
]

export const getCitiesByState = (uf) => {
  console.log('Selecting cities', uf)
  if (!uf || uf === '-') {
    console.log('No UF')
    return ['Selecione o estado']
  }
  // console.log(estados)
  for (let i = 0; i < estados.length; i++) {
    if (estados[i].sigla === uf) {
      let cidades = []
      console.log('Match state', estados[i].sigla)
      cidades = estados[i].cidades
      console.log(cidades[0])
      // cidades.splice(0,0,'')
      return cidades
      // return cidades
    }
  }
}

export const regexSafe = (s) => {
  return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
  //return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
  //.replace(/([^a-zA-Z0-9])/g, "\\$1") // All but AZaz and nums
}

export const capitalizeFirst = (s) => {
  // if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const findByID = (list, id) => {
  let res = -1
  if (!list || !id) { return -1 }
  list.forEach((i, n) => {
    if(parseInt(i.id) === parseInt(id)) {
      res = n
    }
  })
  return res
}

export const humanFileSize = (bytes, si=true, dp=1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si 
    ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10**dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);



  let result = bytes.toFixed(dp) + ' ' + units[u];
  return result.replace(/[.]/g, ',')
}

export const containsID = (list, id) => {
  // console.log('containsID here', list, id)
  let res = false
  if (!list || !id) { return false }
  list.forEach((i) => {
    if(parseInt(i.id) === parseInt(id)) { //podemos comparar String com Number aqui
      res = true
      // break
    }
  })
  // console.log('will return', res)
  return res
}

export const tidyAccents = (s) => {

  if (!s) { return '' }

  let r = s.toLowerCase()
  // r = r.replace(new RegExp("\\s", 'g'),"")
  r = r.replace(new RegExp("[(]", 'g'),"")
  r = r.replace(new RegExp("[)]", 'g'),"")
  r = r.replace(new RegExp("[àáâãäå]", 'g'),"a")
  r = r.replace(new RegExp("æ", 'g'),"ae")
  r = r.replace(new RegExp("ç", 'g'),"c")
  r = r.replace(new RegExp("[èéêë]", 'g'),"e")
  r = r.replace(new RegExp("[ìíîï]", 'g'),"i")
  r = r.replace(new RegExp("ñ", 'g'),"n")
  r = r.replace(new RegExp("[òóôõö]", 'g'),"o")
  r = r.replace(new RegExp("œ", 'g'),"oe")
  r = r.replace(new RegExp("[ùúûü]", 'g'),"u")
  r = r.replace(new RegExp("[ýÿ]", 'g'),"y")
  // r = r.replace(new RegExp("\\W", 'g'),"");
  return r
}

// export const isDateValid = (dateString) => {
//   if (dateString.length !== 10)  { return false }
//   let dateParts = dateString.split('/')
//   let newString = dateParts[1]+'/'+dateParts[0]+'/'+dateParts[2]
//   console.log('Checking', newString)
//   // let d = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
//   let d = new Date(newString)

//   console.log(d)
//     if (isNaN(d.valueOf())) {
//       return false
//     } else {
//       return true
//     }
// }

export const uuid = () => {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    
    // eslint-disable-next-line no-mixed-operators
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export const isDateValid = (dateDDMMYYYY) => {
  if (dateDDMMYYYY.length !== 10)  { return false }
  let m = moment(dateDDMMYYYY, 'DD/MM/YYYY').valueOf()
  // console.log('Checking date', dateDDMMYYYY, 'got', m)
  if (isNaN(m)) {
    // console.log('Not valid!')
    return false
  } else {
    return true
  }
}

export const stringFromStringWithLineBreaks = (s) => {
  // return s.replace(/['/n']/g, `<br />`)
  if (!s) {return ''}
    return s.split('\n').map((item, key) => (
      <span key={key}>{item}<br/></span>
    ))
}

export const stringFromStringWithHTMLLineBreaks = (s) => {
  if(!s) {return ''}
  return s.split('<br />').map((item, key) => (
    <span key={key}>{item}<br /></span>
  ))
}

export const makeDateMask = (d) => {
  // console.log('Making mask for', d)
  // console.log(moment(d, 'DD/MM/YYYY').valueOf())
  d = d.replace(/[_]/g, '')
  d = d.replace('/', '').replace('/', '')
  if (!d) {
    return [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  }
  if (!!d) {
    if (d.length === 0) {
      return [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    }

    if (d.length === 1) {
      if (d[0] === '3') {
        return [/[0-3]/, /[0-1]/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
      }
    }

    if (d.length === 3){
      if (d[2] === '1') {
        return [/[0-3]/, /\d/, '/', /[0-1]/, /[0-2]/, '/', /\d/, /\d/, /\d/, /\d/]
      }
    }

  }
return [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]

}

// export const validaCNPJ = (cnpj) => {
//   cnpj = cnpj.replace(/[^\d]+/g,'');
 
//     if(cnpj === '') return false;
     
//     if (cnpj.length !== 14)
//         return false;
 
//     // Elimina CNPJs invalidos conhecidos
//     if (cnpj === "00000000000000" || 
//         cnpj === "11111111111111" || 
//         cnpj === "22222222222222" || 
//         cnpj === "33333333333333" || 
//         cnpj === "44444444444444" || 
//         cnpj === "55555555555555" || 
//         cnpj === "66666666666666" || 
//         cnpj === "77777777777777" || 
//         cnpj === "88888888888888" || 
//         cnpj === "99999999999999")
//         return false;
         
//     // Valida DVs
//     let tamanho = cnpj.length - 2
//     let numeros = cnpj.substring(0,tamanho);
//     let digitos = cnpj.substring(tamanho);
//     let soma = 0;
//     let pos = tamanho - 7;
//     for (let i = tamanho; i >= 1; i--) {
//       soma += numeros.charAt(tamanho - i) * pos--;
//       if (pos < 2)
//             pos = 9;
//     }
//     let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
//     if (resultado !==  parseInt(digitos.charAt(0)))
//         return false;
         
//     tamanho = tamanho + 1;
//     numeros = cnpj.substring(0,tamanho);
//     soma = 0;
//     pos = tamanho - 7;
//     for (let i = tamanho; i >= 1; i--) {
//       soma += numeros.charAt(tamanho - i) * pos--;
//       if (pos < 2)
//             pos = 9;
//     }
//     resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
//     if (resultado !== parseInt(digitos.charAt(1)))
//           return false;
           
//     return true;
//     }

export const validaCPF = (cpf) => {
  // if(!!cpf) { return false }
  // cpf = cpf.replace(/[.]/g, '').replace(/[-]/g, '')
  cpf = cpf.replace(/\D/g, '')
  // console.log('cpf length is', cpf.length)
  if (cpf.length !== 11) return false

  // console.log('validando cpf', cpf)
  if(cpf.toString().length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false
  let result = true;
  [9,10].forEach(function(j){
      let soma = 0, r
      cpf.split(/(?=)/).splice(0,j).forEach(function(e, i){
          soma += parseInt(e) * ((j+2)-(i+1))
      })
      r = soma % 11;
      r = (r <2) ? 0:11 - r;
      if(r !== parseInt(cpf.substring(j, j+1))) result = false
  })
    return result 
  }

export const makeTelMask = (tel) => {
  if(!!tel) {
    tel = tel.replace('-', '').replace(' ', '').replace('(', '').replace(')', '')
  }
  // console.log('Processing', tel, 'for mask')
  if(tel.length === 0) {
    return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]  
  }

  if (tel[2] === '9' && tel.length >= 10) {
    return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }

  return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]  
}

export const makeTelMaskHash = (tel) => {
  if(!!tel) {
    tel = tel.replace('-', '').replace(' ', '').replace('(', '').replace(')', '')
  }
  // console.log('Processing', tel, 'for mask')
  if(tel.length === 0) {
    return '(##) ####-####'  
  }

  if (tel[2] === '9' && tel.length >= 10) {
    return '(##) #####-####'
  }

  return "(##) ####-####"
}
